
import {
    INIT_MASTER_PRODUCT_INFO,
    REQUEST_MASTER_PRODUCT_START,
    REQUEST_MASTER_PRODUCT_SUCCESS,
    REQUEST_ALL_MASTER_PRODUCT_SUCCESS,
    REQUEST_MASTER_PRODUCT_FAIL,

    POST_MASTER_PRODUCT_START,
    POST_MASTER_PRODUCT_SUCCESS,
    POST_MASTER_PRODUCT_FAIL,

    PATCH_MASTER_PRODUCT_SUCCESS,

    DELETE_MASTER_PRODUCT_START,
    DELETE_MASTER_PRODUCT_SUCCESS,
    DELETE_MASTER_PRODUCT_FAIL,

    REQUEST_DETAIL_MASTER_PRODUCT_START,
    REQUEST_DETAIL_MASTER_PRODUCT_SUCCESS,
    REQUEST_DETAIL_MASTER_PRODUCT_FAIL,

    PUT_MASTER_PRODUCT_START,
    PUT_MASTER_PRODUCT_SUCCESS,
    PUT_MASTER_PRODUCT_FAIL,

    DELETE_MULTIPLE_MASTER_PRODUCT_START,
    DELETE_MULTIPLE_MASTER_PRODUCT_SUCCESS,
    DELETE_MULTIPLE_MASTER_PRODUCT_FAIL,

    PATCH_MULTIPLE_MASTER_PRODUCT_START,
    PATCH_MULTIPLE_MASTER_PRODUCT_SUCCESS,
    PATCH_MULTIPLE_MASTER_PRODUCT_FAIL,

    PUT_MULTIPLE_MASTER_PRODUCT_START,
    PUT_MULTIPLE_MASTER_PRODUCT_SUCCESS,
    PUT_MULTIPLE_MASTER_PRODUCT_FAIL,

    CHECK_BARCODE_START,
    CHECK_BARCODE_SUCCESS,
    CHECK_BARCODE_FAIL,


    IMPORT_MASTER_PRODUCT_START,
    IMPORT_MASTER_PRODUCT_SUCCESS,
    IMPORT_MASTER_PRODUCT_FAIL,

    REQUEST_IMPORT_MASTER_PRODUCT_START,
    REQUEST_IMPORT_MASTER_PRODUCT_SUCCESS,
    REQUEST_IMPORT_MASTER_PRODUCT_FAIL,

    SEARCH_PRODUCT_FAIL,
    SEARCH_PRODUCT_START,
    SEARCH_PRODUCT_SUCCESS,

} from '../actions/master-product';

export const initialState = { error: null, data: null, isLoading: false }

export const reducer = (state = initialState, action) => {

    const { type, data, payload, error } = action;

    switch (type) {

        case REQUEST_MASTER_PRODUCT_START:
            {
                // console.log(type, { state, action, payload })
                return { ...state, data: { ...payload.req, isLoading: true, type } }
            }

        case REQUEST_MASTER_PRODUCT_SUCCESS:
            {
                /*console.log(type, { state, action, payload })*/
                return { ...state, data: { ...payload.res, isLoading: false, type } }
            }

        case REQUEST_ALL_MASTER_PRODUCT_SUCCESS:
            {
                // console.log(type, { state, action, payload })
                return { ...state, data: { ...payload.res, isLoading: false, type } }
            }

        case REQUEST_MASTER_PRODUCT_FAIL:
            {
                /*console.log(type, { state, action, payload })*/
                return { ...state, data: { ...payload.res, isLoading: false, type } }
            }

        // ----------------------------------------

        case POST_MASTER_PRODUCT_START:
            {
                // console.log(type, { state, action, payload })
                return { ...state, data: { ...payload.req, isLoading: true, type } }
            }

        case POST_MASTER_PRODUCT_SUCCESS:
            {
                // console.log(type, { state, action, payload })
                return { ...state, data: { ...payload.res, isLoading: false, type } }
            }

        case POST_MASTER_PRODUCT_FAIL:
            {
                /*console.log(type, { state, action, payload })*/
                return { ...state, data: { ...payload.res, isLoading: false, type } }
            }

        // ----------------------------------------

        case PATCH_MASTER_PRODUCT_SUCCESS:
            {
                // console.log(type, { state, action, payload })
                return { ...state, data: { ...payload.res, isLoading: false, type } }
            }

        //--------------------------------------

        case DELETE_MASTER_PRODUCT_START:
            {
                // console.log(type, { state, action, payload })
                return { ...state, data: { ...payload.req, isLoading: true, type } }
            }

        case DELETE_MASTER_PRODUCT_SUCCESS:
            {
                // console.log(type, { state, action, payload })
                return { ...state, data: { ...payload.res, isLoading: false, type } }
            }

        case DELETE_MASTER_PRODUCT_FAIL:
            {
                /*console.log(type, { state, action, payload })*/
                return { ...state, data: { ...payload.res, isLoading: false, type } }
            }

        //--------------------------------------

        case REQUEST_DETAIL_MASTER_PRODUCT_START:
            {
                // console.log(type, { state, action, payload })
                return { ...state, data: { ...payload.req, isLoading: true, type } }
            }

        case REQUEST_DETAIL_MASTER_PRODUCT_SUCCESS:
            {
                // console.log(type, { state, action, payload })
                return { ...state, data: { ...payload.res, isLoading: false, type } }
            }

        case REQUEST_DETAIL_MASTER_PRODUCT_FAIL:
            {
                /*console.log(type, { state, action, payload })*/
                return { ...state, data: { ...payload.res, isLoading: false, type } }
            }

        // ----------------------------------------

        case PUT_MASTER_PRODUCT_START:
            {
                // console.log(type, { state, action, payload })
                return { ...state, data: { ...payload.req, isLoading: true, type } }
            }

        case PUT_MASTER_PRODUCT_SUCCESS:
            {
                // console.log(type, { state, action, payload })
                return { ...state, data: { ...payload.res, isLoading: false, type } }
            }

        case PUT_MASTER_PRODUCT_FAIL:
            {
                // console.log(type, { state, action, payload })
                return { ...state, data: { ...payload.res, isLoading: false, type } }
            }

        // ----------------------------------------


        case DELETE_MULTIPLE_MASTER_PRODUCT_START:
            {
                // console.log(type, { state, action, payload })
                return { ...state, data: { ...payload.req, isLoading: true, type } }
            }

        case DELETE_MULTIPLE_MASTER_PRODUCT_SUCCESS:
            {
                // console.log(type, { state, action, payload })
                return { ...state, data: { ...payload.res, isLoading: false, type } }
            }

        case DELETE_MULTIPLE_MASTER_PRODUCT_FAIL:
            {
                // console.log(type, { state, action, payload })
                return { ...state, data: { ...payload.res, isLoading: false, type } }
            }

        // ----------------------------------------


        case PATCH_MULTIPLE_MASTER_PRODUCT_START:
            {
                // console.log(type, { state, action, payload })
                return { ...state, data: { ...payload.req, isLoading: true, type } }
            }

        case PATCH_MULTIPLE_MASTER_PRODUCT_SUCCESS:
            {
                // console.log(type, { state, action, payload })
                return { ...state, data: { ...payload.res, isLoading: false, type } }
            }

        case PATCH_MULTIPLE_MASTER_PRODUCT_FAIL:
            {
                // console.log(type, { state, action, payload })
                return { ...state, data: { ...payload.res, isLoading: false, type } }
            }

        // ----------------------------------------


        case PUT_MULTIPLE_MASTER_PRODUCT_START:
            {
                // console.log(type, { state, action, payload })
                return { ...state, data: { ...payload.req, isLoading: true, type } }
            }

        case PUT_MULTIPLE_MASTER_PRODUCT_SUCCESS:
            {
                // console.log(type, { state, action, payload })
                return { ...state, data: { ...payload.res, isLoading: false, type } }
            }

        case PUT_MULTIPLE_MASTER_PRODUCT_FAIL:
            {
                /*console.log(type, { state, action, payload })*/
                return { ...state, data: { ...payload.res, isLoading: false, type } }
            }

        // ----------------------------------------

        case CHECK_BARCODE_START:
            {
                // console.log(type, { state, action, payload })
                return { ...state, data: { ...payload.req, isLoading: true, type } }
            }

        case CHECK_BARCODE_SUCCESS:
            {
                // console.log(type, { state, action, payload })
                return { ...state, data: { ...payload.res, isLoading: false, type } }
            }

        case CHECK_BARCODE_FAIL:
            {
                /*console.log(type, { state, action, payload })*/
                return { ...state, data: { ...payload.res, isLoading: false, type } }
            }

        // ----------------------------------------


        case IMPORT_MASTER_PRODUCT_START:
            {
                // console.log(type, { state, action, payload })
                return { ...state, data: { ...payload.req, isLoading: true, type } }
            }

        case IMPORT_MASTER_PRODUCT_SUCCESS:
            {
                // console.log(type, { state, action, payload })
                return { ...state, data: { ...payload.res, isLoading: false, type } }
            }

        case IMPORT_MASTER_PRODUCT_FAIL:
            {
                /*console.log(type, { state, action, payload })*/
                return { ...state, data: { ...payload.res, isLoading: false, type } }
            }

        // ----------------------------------------

        case REQUEST_IMPORT_MASTER_PRODUCT_START:
            {
                // console.log(type, { state, action, payload })
                return { ...state, data: { ...payload.req, isLoading: true, type } }
            }

        case REQUEST_IMPORT_MASTER_PRODUCT_SUCCESS:
            {
                // console.log(type, { state, action, payload })
                return { ...state, data: { ...payload.res, isLoading: false, type } }
            }

        case REQUEST_IMPORT_MASTER_PRODUCT_FAIL:
            {
                /*console.log(type, { state, action, payload })*/
                return { ...state, data: { ...payload.res, isLoading: false, type } }
            }

        // ----------------------------------------

        case SEARCH_PRODUCT_START:
            {
                // console.log(type, { state, action, payload })
                return { ...state, data: { ...payload.req, isLoading: true, type } }
            }

        case SEARCH_PRODUCT_SUCCESS:
            {
                // console.log(type, { state, action, payload })
                return { ...state, data: { ...payload.res, isLoading: false, type } }
            }

        case SEARCH_PRODUCT_FAIL:
            {
                /*console.log(type, { state, action, payload })*/
                return { ...state, data: { ...payload.res, isLoading: false, type } }
            }

        // ----------------------------------------


        case INIT_MASTER_PRODUCT_INFO:
            {
                return initialState;
            }

        default:
            {
                return { ...state };
            }
    }
};

export default reducer;
